import React, { useState } from 'react';
import './ContactForm.css';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const ContactForm = () => {
  // State for form inputs
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: '',
  });

  // State for success/failure message
  const [statusMessage, setStatusMessage] = useState(null);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const onSubmit = async (event) => {
    event.preventDefault();
    
    const data = new FormData(event.target);
    data.append('access_key', '376ab345-2465-4ae3-8c39-2744c65be09b');
    
    const object = Object.fromEntries(data);
    const json = JSON.stringify(object);
    
    try {
      const res = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: json,
      }).then((res) => res.json());

      if (res.success) {
        // Reset form data if submission is successful
        setFormData({
          name: '',
          email: '',
          phone: '',
          subject: '',
          message: '',
        });
        setStatusMessage({ type: 'success', message: 'Your message has been sent successfully!' });
      } else {
        setStatusMessage({ type: 'error', message: 'There was an issue sending your message. Please try again.' });
      }
    } catch (error) {
      setStatusMessage({ type: 'error', message: 'An error occurred. Please try again later.' });
    }
  };

  return (
    <>
      <Helmet>
             <script type="application/ld+json">
               {JSON.stringify({
                 "@context": "https://schema.org",
                 "@type": "Organization",
                 "name": "Om Sai PG",
                 "description": "Om Sai PG offers affordable PG accommodations in Kharadi, Pune, with food, for students, working professionals, and residents, near Eon IT Park.",
                 "url": "https://www.omsaipg.in",
                 "logo": "https://www.omsaipg.in/images/logo.jpg",
                 "image": "https://www.omsaipg.in/images/ogimage.jpg",
                 "contactPoint": [
                   {
                     "@type": "ContactPoint",
                     "telephone": "+91 9763888448",
                     "contactType": "Customer Service",
                     "areaServed": "IN",
                     "availableLanguage": "English",
                   },
                   {
                     "@type": "ContactPoint",
                     "telephone": "+91 9922248255",
                     "contactType": "Customer Service",
                     "areaServed": "IN",
                     "availableLanguage": "English",
                   },
                 ],
                 "aggregateRating": {
                   "@type": "AggregateRating",
                   "bestRating": "5",
                   "worstRating": "1",
                   "ratingValue": "4.7",
                   "ratingCount": "250",
                 },
                 "email": "omsaipg@gmail.com",
                 "address": {
                   "@type": "PostalAddress",
                   "streetAddress": "Tulja Bhavani Nagar, Lane No 7, Near Durga Mata Mandir",
                   "addressLocality": "Kharadi",
                   "addressRegion": "Maharashtra",
                   "postalCode": "411014",
                   "addressCountry": "IN",
                 },
                 "sameAs": [
                   "https://www.facebook.com/omsaipg",
                   "https://www.instagram.com/omsaipg",
                   "https://www.linkedin.com/company/omsaipg"
                 ],
                 "priceRange": "INR 8,500-6000",
                 "paymentAccepted": "Cash, UPI, Credit Card",
                 "telephone": "+91 9763888448",
                 "email": "omsaipgpune@gmail.com",
                 "keywords": [
                   "PG in Pune",
                   "PG in Kharadi",
                   "PG with food in Pune",
                   "PG for students in Kharadi",
                   "PG for females in Pune",
                   "PG for males in Pune",
                   "Om Sai PG Kharadi",
                   "Girls Hostels in Kharadi",
                   "Boys Hostel in Kharadi",
                   "Monthly Basis PG in Kharadi",
                   "PG in Wagholi",
                   "PG in Kharadi with food",
                   "Hostels in Pune",
                   "PG for Students in Kharadi Pune",
                   "Paying Guest Hostel in Chandan Nagar"
                 ],
                 "openingHours": "Mo-Su 09:00-22:00"
               })}
             </script>
     
             {/* Title */}
             <title>
               Contact : +91 9763888448 / +91 9922248255 | Om Sai PG | Contact | PG In Pune | Single Room PG in Pune | PG in Kharadi | Best Luxury PG in Pune
             </title>
     
             {/* Meta Tags */}
             <meta
               name="description"
               content="Om Sai PG offers the best PG accommodations in Kharadi, Pune. We provide PG for students, males, females, with food and other essential amenities."
             />
             <meta
               name="keywords"
               content="PG in Pune, PG in Kharadi, PG with food in Pune, PG for students in Kharadi, PG for females in Pune, PG for males in Pune, Om Sai PG Kharadi, Girls Hostels in Kharadi"
             />
             <meta name="robots" content="index, follow" />
     
             {/* Open Graph Tags */}
             <meta
               property="og:title"
               content="Om Sai PG - Best PG Accommodation in Kharadi Pune | PG with Food | Paying Guest in Kharadi"
             />
             <meta
               property="og:description"
               content="Looking for the best PG in Kharadi Pune? Om Sai PG offers comfortable and affordable accommodation for students, professionals, and residents with food included."
             />
             <meta property="og:image" content="https://www.omsaipg.in/ogimage.jpg" />
             <meta property="og:url" content="https://www.omsaipg.in" />
             <meta property="og:type" content="website" />
           </Helmet>

      <section className="section-breadcrumb padding-b-50">
        <div className="rx-breadcrumb-image bg-img">
          <div className="rx-breadcrumb-overlay"></div>
          <div className="inner-breadcrumb-contact">
            <div className="main-breadcrumb-contact">
              <div className="container">
                <div className="row">
                  <div className="col-12">
                    <div className="rx-banner-contact">
                      <h2>Contact Form</h2>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="rx-banner-breadcrumb">
              <div className="container">
                <div className="row">
                  <div className="col-12">
                    <div className="breadcrumb-contact">
                      <div className="main-heading">
                        <h4>Contact Form</h4>
                      </div>
                      <div className="last-contact">
                        <ul>
                          <li>
                            <Link to="/">Home</Link>
                          </li>
                          <li>Contact Form</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="contact-container container m-auto">
        <div className="contact-form">
          <h2>Contact Us</h2>
          <form onSubmit={onSubmit}>
            <div className="form-group">
              <label htmlFor="name">Name</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="phone">Phone</label>
              <input
                type="tel"
                id="phone"
                name="phone"
                value={formData.phone}
                onChange={handleInputChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="subject">Subject</label>
              <input
                type="text"
                id="subject"
                name="subject"
                value={formData.subject}
                onChange={handleInputChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="message">Message</label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleInputChange}
                required
              ></textarea>
            </div>

            <button type="submit" className="submit-btn">
              Send Message
            </button>
          </form>

          {statusMessage && (
            <div className={`status-message ${statusMessage.type}`}>
              {statusMessage.message}
            </div>
          )}
        </div>

        <div className="address-info">
          <h3>Our Address</h3>
          <div className="address-content">
            <p className="text-white pb-2">
              Om Sai PG <br/> Tulja Bhavani Nagar,Lane No 7,<br/> Near Durga Mata Mandir, 
              <br/>Kharadi Pune - 411014
            </p>
            <p className="text-white">
              <strong>Phone:</strong> +91 9763888448 / +91 9922248255
            </p>
            <p className="text-white mt-2">
              <strong>Email:</strong>{' '}
              <a href="mailto:omsaipgpune@gmail.com" className="text-white">
                omsaipgpune@gmail.com
              </a>
            </p>
          </div>

          <h4>Location</h4>
          
          <div style={{ position: 'relative', overflow: 'hidden', paddingTop: '', height: '400px', maxWidth: '100%' }}>
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d56881.68616005074!2d73.88729343290177!3d18.55597545061753!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2c3f1982d6b2b%3A0x74125aedd2bd98c6!2sOM%20SAI%20PG!5e1!3m2!1sen!2sin!4v1740637774676!5m2!1sen!2sin"
        width="100%"
        height="100%"
        style={{ border: 0 }}
        allowFullScreen
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        title="Om Sai PG Location"
      ></iframe>
    </div>
        </div>
      </div>
    </>
  );
};

export default ContactForm;
